/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import NoteResponse from './NoteResponse';

/**
* The GetNoteResponse model module.
* @module model/GetNoteResponse
* @version 2020-12-7
*/
export default class GetNoteResponse {
    /**
    * Constructs a new <code>GetNoteResponse</code>.
    * 通知取得レスポンス
    * @alias module:model/GetNoteResponse
    * @class
    * @param note {module:model/NoteResponse} 
    * @param result {module:model/GetNoteResponse.ResultEnum} 
    */

    constructor(note, result) {
        
        
        this['note'] = note;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>GetNoteResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GetNoteResponse} obj Optional instance to populate.
    * @return {module:model/GetNoteResponse} The populated <code>GetNoteResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetNoteResponse();
                        
            
            if (data.hasOwnProperty('note')) {
                obj['note'] = NoteResponse.constructFromObject(data['note']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {module:model/NoteResponse} note
    */
    'note' = undefined;
    /**
    * @member {module:model/GetNoteResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
